/* =============================================================================
 * PHOTOS — every image slot on the public site, in one place.
 *
 * How to add a photo:
 *   1. Put the file in  static/images/   (e.g. static/images/hero.webp)
 *   2. Reference it here as '/images/hero.webp'
 *   3. Rebuild. Files in static/ are copied to the site as-is.
 *
 * Tips: resize to ≤ 1600 px wide and save as .webp or .jpg (≈ 150–300 KB);
 * many candidates are on mobile data. Always write a Marathi `alt` text.
 *
 * Any slot left as null / [] simply doesn't appear — the page layout adapts.
 * ========================================================================== */

export interface Photo {
  src: string;
  alt: string;
  caption?: string;
  /** CSS `object-position` — adjusts the crop when the image is wider/taller than its frame. */
  objectPosition?: string;
}

// The home page hero's background photo (Shivaji Maharaj's portrait, themed after
// the competition poster) isn't here — it's a CSS background, not an <img>/Photo
// slot, so it's set directly in apps/public/public.css's `.hero` rule.

export const IMAGES = {
  /** Home page gallery strip — e.g. last year's competition, prize distribution. */
  homeGallery: [] as Photo[],
};

/**
 * Show dashed "photo goes here" frames for empty slots. On in the demo build so
 * you can see where images will sit; off in production.
 */
export const SHOW_EMPTY_IMAGE_SLOTS = import.meta.env.VITE_USE_MOCK === 'true';
